import { render, staticRenderFns } from "./TheCalling.vue?vue&type=template&id=2d3937e0&scoped=true"
import script from "./TheCalling.vue?vue&type=script&lang=js"
export * from "./TheCalling.vue?vue&type=script&lang=js"
import style0 from "./TheCalling.vue?vue&type=style&index=0&id=2d3937e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3937e0",
  null
  
)

export default component.exports